<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    class="EditTopicComment"
    title="Edit Comment"
    submit-name="Save changes"
    full-height
    disable-tabindex
    @submit="submit"
    @[Events.AFTER_CLOSE]="modalClosed"
  >
    <lm-editor
      v-if="!dataError"
      ref="textEditor"
      v-model="text"
      type="comment"
      :optional="false"
      @submit="submit()"
    />
  </form-modal>
</template>

<script>
import {mapGetters} from 'vuex'
import {Events, Modal} from '@/lib/definitions'
import EventHub from '@/lib/eventHub'
import FormModal from '@/components/modals/FormModal'
import LmEditor from '@/components/form/LmEditor'
import FormHelper from '@/components/form/formHelper'

export default {
  name: 'ModalEditComment',
  components: {
    LmEditor,
    FormModal
  },
  data() {
    return {
      Events,
      modalName: Modal.EDIT_COMMENT,
      modalRef: null,
      bounds: '.EditTopicComment',
      text: '',
      inEditCommentId: null,
      dataError: false
    }
  },
  computed: mapGetters(['currentComment']),
  mounted() {
    this.modalRef = this.$refs[this.modalName]
    this.inputs = [this.$refs.textEditor]
    this.init()
  },
  methods: {
    init() {
      if (
        this.currentComment &&
        this.inEditCommentId !== this.currentComment._id
      ) {
        this.inEditCommentId = this.currentComment._id
        FormHelper.clearErrors(this.inputs)
        this.updateInputData()
      } else {
        this.dataError = true
      }
    },
    updateInputData() {
      this.text = this.currentComment.text
    },
    submit() {
      if (FormHelper.validate(this.inputs)) {
        this.$store
          .dispatch('editComment', {
            text: this.text,
            mentions: FormHelper.getEditorMentions()
          })
          .then(() => this.modalRef.submitSuccess())
          .catch(error => this.modalRef.submitFails(error))
      } else {
        this.modalRef.submitFails()
      }
    },
    modalClosed({fromSubmit}) {
      if (fromSubmit) {
        EventHub.emit(Events.SHOW_SNACKBAR, 'Comment updated')
      }
      this.$store.dispatch('unsetComment')
    }
  }
}
</script>
